export const getBadges = (campaigns: any[], campaignIds: string[]) => {
  const badges = campaignIds.flatMap((id) => {
    const campaign = campaigns.find((campaign) => campaign.id === id);

    const badges = campaign?.content?.badges
      ? campaign.isAssortment
        ? campaign?.content?.badges.map((badge) => ({ ...badge, isAssortment: true }))
        : campaign?.content?.badges
      : [];

    return badges;
  });
  return badges.sort((a, b) => b.title.length - a.title.length);
};
